import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoadingIndicatorModule } from "wspowerpack";
import { AuthService } from "../../core/services/auth.service";
import { AccountClient, AccountV1Model } from "src/app/api/client";
import { Router } from "@angular/router";

@Component({
  selector: "app-expired",
  standalone: true,
  imports: [CommonModule, LoadingIndicatorModule],
  templateUrl: "./expired.component.html",
  styleUrls: ["./expired.component.scss"],
})
export class ExpiredComponent {
  isLoading = false;
  account: AccountV1Model;
  currentAccountId: number;

  constructor(private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    //console.log(this.authService.user);
    if(this.authService.user.isExpired == false){
      //console.log("User is not expired");
      this.router.navigateByUrl(this.authService.getHome());
    }
  }
}
